import colorCategoryApi from '../../api/color-category'

// initial state
const state = {
  colorCategories: []
}

const getters = {
}

const actions = {
  getAll ({ commit }) {
    colorCategoryApi.getAll(cats => {
      commit('setAllCategories', cats)
    })
  },
}

const mutations = {
  setAllCategories (state, cats) {
    state.colorCategories = cats
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
